import { gql } from "@apollo/client"

export const CHECKOUT_CREATE = gql`
  mutation checkoutCreate(
    $channel: String!
    $email: String!
    $lines: [CheckoutLineInput!]!
    $bFirstName: String!
    $bLastName: String!
    $bStreetAdress1: String!
    $bStreetAdress2: String
    $bCity: String!
    $bPostalCode: String!
    $bCountry: CountryCode!
    $bCountryArea: String
    $bCompany: String!
    $bPhone: String!
    $sFirstName: String!
    $sLastName: String!
    $sStreetAdress1: String!
    $sStreetAdress2: String
    $sCity: String!
    $sPostalCode: String!
    $sCountry: CountryCode!
    $sCountryArea: String
    $sPhone: String!
  ) {
    checkoutCreate(
      input: {
        channel: $channel
        email: $email
        lines: $lines
        shippingAddress: {
          firstName: $sFirstName
          lastName: $sLastName
          streetAddress1: $sStreetAdress1
          streetAddress2: $sStreetAdress2
          city: $sCity
          postalCode: $sPostalCode
          country: $sCountry
          countryArea: $sCountryArea
          phone: $sPhone
        }
        billingAddress: {
          firstName: $bFirstName
          lastName: $bLastName
          streetAddress1: $bStreetAdress1
          streetAddress2: $bStreetAdress2
          city: $bCity
          postalCode: $bPostalCode
          country: $bCountry
          countryArea: $bCountryArea
          phone: $bPhone
          companyName: $bCompany
        }
      }
    ) {
      checkout {
        id
        token
        totalPrice {
          gross {
            amount
            currency
          }
        }
        isShippingRequired
        shippingMethods {
          id
          name
          active
          message
          price {
            amount
            currency
          }
        }
        availableCollectionPoints {
          id
          name
          clickAndCollectOption
        }
        availablePaymentGateways {
          id
          name
          config {
            field
            value
          }
        }
      }
      errors {
        field
        code
        message
      }
    }
  }
`
